import {
  LucideHome,
  LoaderCircle,
  CornerRightDown,
  RotateCcw,
  Eye,
  EyeOff,
  Filter,
  FilterX,
  ArrowLeft,
  History,
  LayoutDashboard,
  Trash,
  ZoomIn,
  ShieldAlert,
  Search,
  PanelLeftOpen,
  PanelLeftClose,
  SunMoon,
  Moon,
  Sun,
  Languages,
  CircleUserRound,
  UserRoundCog,
  Settings,
  LogOut,
  CircleHelp,
  Info,
  CircleX,
  Users,
  Mail,
  SquareUserRound,
  MessageSquareMore,
  UsersRound,
  AppWindow,
  BellRing,
  Logs,
  Lock,
  ShieldBan,
  EllipsisVertical,
  ShieldCheck,
  ChevronFirst,
  ChevronLast,
  RefreshCcw,
  UserRoundPlus,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Check,
  Dot,
  ImagePlus,
  House,
} from 'lucide-vue-next';
const iconList = {
  LucideHome,
  LoaderCircle,
  CornerRightDown,
  RotateCcw,
  RefreshCcw,
  Eye,
  EyeOff,
  Filter,
  FilterX,
  Settings,
  ArrowLeft,
  History,
  LayoutDashboard,
  Trash,
  ZoomIn,
  ShieldAlert,
  Search,
  PanelLeftOpen,
  PanelLeftClose,
  SunMoon,
  Moon,
  Sun,
  Languages,
  CircleUserRound,
  UserRoundCog,
  LogOut,
  CircleHelp,
  Info,
  CircleX,
  Users,
  Mail,
  SquareUserRound,
  MessageSquareMore,
  UsersRound,
  AppWindow,
  BellRing,
  Logs,
  Lock,
  ShieldBan,
  ShieldCheck,
  EllipsisVertical,
  ChevronFirst,
  ChevronLast,
  UserRoundPlus,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Check,
  Dot,
  ImagePlus,
  House,
};
export default iconList;
